import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-4" }
const _hoisted_3 = { class: "field col-12 lg:col-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "field col-12 lg:col-3" }, null, -1)
const _hoisted_5 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_7 = {
  key: 0,
  class: "col-12"
}
const _hoisted_8 = {
  key: 1,
  class: "field col-12 text-right"
}
const _hoisted_9 = {
  key: 2,
  class: "col-12"
}
const _hoisted_10 = { class: "text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("employee.employee")), 1),
        _createVNode(_component_Dropdown, {
          filter: true,
          options: _ctx.employees,
          optionLabel: "fullName",
          optionValue: "id",
          placeholder: "-",
          modelValue: _ctx.employeeId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employeeId) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataChanged()))
        }, null, 8, ["options", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statEmployeeMonthReport.month")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.monthDate,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.monthDate) = $event)),
          options: _ctx.months,
          onChange: _ctx.dataChanged,
          optionLabel: "label",
          optionValue: "date",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults && _ctx.results.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_Button, {
              label: _ctx.t('buttons.print'),
              icon: "pi pi-print",
              class: "p-button-primary p-uppercase",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.printPaper()))
            }, null, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_DataTable, {
              dataKey: "date",
              groupRowsBy: "date",
              responsiveLayout: "scroll",
              rowGroupMode: "rowspan",
              showGridlines: "",
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "date",
                  header: _ctx.t('statEmployeeMonthReport.date'),
                  bodyClass: "day-cell",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass({
                  'flex justify-content-center align-items-center': true,
                  holiday: _ctx.dateHolidays.isHoliday(data[field]),
                  saturday: data[field].getDay() === 6,
                  sunday: data[field].getDay() === 0,
                  leave: _ctx.dayHasLeave(data[field]),
                  suspension: _ctx.dayHasSuspension(data[field]),
                })
                    }, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.d(data[field], "longDate")), 1)
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "label",
                  header: _ctx.t('statEmployeeMonthReport.label'),
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(_ctx.t(`statEmployeeMonthReport.labels.${data[field]}`)), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "value",
                  header: _ctx.t('statEmployeeMonthReport.value'),
                  headerStyle: "width: 60%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createTextVNode(_toDisplayString(data[field] ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_component_DataTable, {
              class: "mt-4",
              responsiveLayout: "scroll",
              showGridlines: "",
              value: _ctx.counterResults
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "label",
                  header: _ctx.t('employeeRoster.counter.label'),
                  style: {"width":"80%"}
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'text-bold': data[field].includes(_ctx.t('branch.branch')) })
                    }, _toDisplayString(data[field]), 3)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "value",
                  header: _ctx.t('employeeRoster.counter.value'),
                  bodyClass: "text-center",
                  style: {"width":"20%"}
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass({ 'text-bold': data[field] != 0 })
                    }, _toDisplayString(_ctx.n(data[field], "number1")), 3)
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}